<mat-toolbar class="mc-toolbar-large" color="basic">
  <ng-container *ngIf="showItems">
    <ng-container *ngIf="lineCount >= 0">
      <span>{{ lineCount | mcPluralize : 'line' }}</span>
      <mat-divider [vertical]="true"></mat-divider>
    </ng-container>

    <span *ngIf="docSize >= 0">{{ docSize | mcFileSize }}</span>

    <ng-content></ng-content>

    <ng-container *ngIf="mode === 'code' && showCannotEditCodeMessage$ | async">
      <mat-divider [vertical]="true"></mat-divider>
      <span class="mc-text-warn">You must have the Edit Code permission to modify this document.</span>
    </ng-container>

    <ng-container *ngIf="mode === 'text' && showCannotEditFileMessage$ | async">
      <mat-divider [vertical]="true"></mat-divider>
      <span class="mc-text-warn">You must have the Create/Edit Files permission to modify this document.</span>
    </ng-container>

    <span class="mc-fill-remaining-flex-space"></span>
    <span>
      <mat-icon fontSet="project-titan" fontIcon="icon-hamster" class="mc-centered-text-icon mc-image-icon mc-image-icon-xxx-small"></mat-icon>
      Workspace
    </span>
  </ng-container>
</mat-toolbar>